@if (isGeneratedLine()) {
  <div class="mb-1 text-xs text-surface-400">
    @if (billingPeriodStart()) {
      {{ 'invoice.generated-line-period' | translate: {start: (billingPeriodStart() | date:'dd/MM/yyyy'), end: (billingPeriodEnd() | date:'dd/MM/yyyy')} }}
    } @else {
      {{ 'invoice.generated-line' | translate }}
    }
  </div>
}

<div class="flex gap-4">
  <div class="w-50">
    <elcia-invoice-product-dropdown
      (nameResolved)="fg().controls.label.setValue($event)"
      (productSelected)="onProductSelected($event)"
      (unitPriceResolved)="fg().controls.unitPrice.setValue($event)"
      [control]="fg().controls.productId"
      [invoiceDate]="invoiceDate()"
      [isMulti]="false"
      [legalEntityId]="legalEntityId()"
    />
  </div>
  <div class="flex-1">
    <elcia-text-input [control]="fg().controls.label" [label]="'invoice.label' | translate"/>
  </div>
  <div class="w-50">
    <elcia-numeric-input [control]="fg().controls.quantity" [label]="'invoice.quantity' | translate"
                         data-testid="invoice-line-quantity"
                         mode="decimal"/>
  </div>
  <div class="w-50">
    <elcia-numeric-input [control]="fg().controls.unitPrice" [label]="'invoice.unit-price' | translate"
                         currency="EUR" data-testid="invoice-line-unit-price" mode="currency"/>
  </div>
  <div class="w-50">
    <elcia-numeric-input [control]="amountOfLine" [label]="'invoice.amount' | translate"
                         currency="EUR" mode="currency"/>
  </div>
  <div class="w-50">
    <elcia-tax-dropdown [control]="fg().controls.taxId" [isMulti]="false"/>
  </div>
  <div class="flex items-center gap-2 self-center">
    <elcia-button (onClick)="timesheetPickerOpen.set(true)"
                  class="timesheet-picker-button"
                  [icon]="'clock'"
                  [label]="fg().controls.timesheetIds.value.length > 0 ? fg().controls.timesheetIds.value.length + '' : ''"
                  [severity]="fg().controls.timesheetIds.value.length > 0 ? 'primary' : 'secondary'"
                  [style.visibility]="canOpenTimesheetPicker() && !isTravelExpenses() ? 'visible' : 'hidden'"
    />
    <elcia-button (onClick)="toggleDescription()"
                  [icon]="'align-center'"
                  [severity]="descriptionVisible() ? 'primary' : 'secondary'"
    />
    <elcia-button (onClick)="remove()" [icon]="'minus'" [severity]="'secondary'"/>
  </div>
</div>

@if (descriptionVisible()) {
  <!-- Tighter top margin than the parent's gap-4 so the description stays grouped with this line, not the next one -->
  <div class="mt-2">
    <elcia-text-area [control]="fg().controls.description" [label]="'invoice.description' | translate" [rows]="2"/>
  </div>
}

@if (timesheetPickerOpen() && customerId() != null && currentTimesheetTypeId() != null) {
  <elcia-invoice-timesheet-picker
    (confirmed)="onTimesheetsConfirmed($event)"
    (onClose)="timesheetPickerOpen.set(false)"
    [customerId]="customerId()!"
    [initialSelectedIds]="fg().controls.timesheetIds.value"
    [timesheetTypeId]="currentTimesheetTypeId()!"
  />
}
